import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Islands, OnboardingPages, Pages } from '../../../../common/src/pages.ts';
import { useHousehold } from '../../data/use_household.tsx';
import { getPageFromLocation } from '../../util/path.ts';
import { isHymnUrl } from '../../util/shared.tsx';
import { isEventIsland } from '../event_island.tsx';
import { navigateToOnboardingPage } from './common.tsx';

export function useDisplayDemoPage() {
  const { household } = useHousehold();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const page = getPageFromLocation(location);
    if (
      household ||
      page === Pages.Onboarding ||
      page === Pages.EngineeringAudioLab || // research page; gated separately by useInternalPage
      page === Pages.Tutorials ||
      page === Pages.AdminInvite ||
      page === Pages.HouseholdInvite ||
      page === Pages.DeprecatedHouseholdInvite ||
      isEventIsland(page, location.search) ||
      isHymnUrl(location.search) ||
      Object.values(Islands).includes(location.pathname.split('/')[1] as Islands)
    ) {
      return;
    }
    // TODO(hewitt): On iOS (and iOS Safari) triggers a server request for /onboarding#demo instead of client routing.
    //               If we sleep or run `setTimeout`, it does not, but then it fails to navigate immediately.
    void navigateToOnboardingPage(navigate, OnboardingPages.Demo);
  }, [household, location, navigate]);
}
